export default "/staticreactui/static/media/static/media/customer6.f069df03.png";